document.addEventListener('DOMContentLoaded', function() {
  
  var params = new URLSearchParams(window.location.search);
  var simCode = params.get('simCode');

  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;
  const datepicker = document.getElementById('datepicker');
  
  if (datepicker) {
    datepicker.placeholder = formattedDate;
    datepicker.value = formattedDate;
    
    const today = new Date().toISOString().split("T")[0];
    datepicker.min = today;

    datepicker.addEventListener("click", () => {
      datepicker.showPicker?.();
    });
    
  }
  
  if (simCode) {
    var iccidInput = document.getElementById('iccid');
    if (iccidInput) {
        iccidInput.value = simCode;
        iccidInput.readOnly = true;
    } else if (iccidInput) {
        iccidInput.readOnly = false;
    }
  }
  
});


  document.addEventListener("DOMContentLoaded", function () {
    const requiredInput = document.getElementById("iccid");
    const paypalWrapper = document.querySelector(".shopify-payment-button");

    if (!requiredInput || !paypalWrapper) return;

    // Create blocker overlay
    const blocker = document.createElement("div");
    blocker.id = "paypal-blocker";
    paypalWrapper.style.position = "relative";
    paypalWrapper.appendChild(blocker);

    // Create tooltip
    const tooltip = document.createElement("div");
    tooltip.id = "paypal-tooltip";
    tooltip.textContent = "Please enter your SIM code first.";
    paypalWrapper.appendChild(tooltip);

    function togglePayPalAccess() {
      const isEmpty = requiredInput.value.trim() === "";
      blocker.style.display = isEmpty ? "block" : "none";
      tooltip.style.display = "none";
    }

    // Check on input change
    requiredInput.addEventListener("input", togglePayPalAccess);

    // Show tooltip if user clicks while input is empty
    blocker.addEventListener("click", () => {
      tooltip.style.display = "block";
      setTimeout(() => {
        tooltip.style.display = "none";
      }, 3000);
    });

    // Initial check
    togglePayPalAccess();
  });

